export const enum DeviceType {
  PC = "pc",
  MO = "mobile",
  TABLET = "tablet",
}
export type Device = DeviceType.PC | DeviceType.MO | DeviceType.TABLET;
